import { jsx as _jsx } from "react/jsx-runtime";
function ArrowDownLeft({ className, size = 24 }) {
    return (_jsx("svg", { className: className, height: size, width: size, fill: "currentColor", viewBox: "0 0 24 24", children: _jsx("path", { d: "M15.4974 7.41667L16.5833 8.50256L9.13716 15.9487H15.8077V17.5H6.49998V8.19231H8.05126V14.8628L15.4974 7.41667Z" }) }));
}
export default ArrowDownLeft;
